export default {"src":"/pro/_next/static/media/abstract.d2dd7317.svg","height":127,"width":141,"blurWidth":0,"blurHeight":0};